import { createContext, useContext } from "react";

const Ctx = createContext(236);

export const UnitSizeProvider = Ctx.Provider;

export const useUnitSize = () => useContext(Ctx);
const useScaleFactor = () => useContext(Ctx) / 238;
